import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { HintTooltip } from 'components/tooltip'
import ClickOutside from 'decorators/click_outside/click_outside_decorator'
import { localize } from 'helpers/translator'
import TopbarButton from 'components/topbar/main/button/topbar_button'
import CreationMenuComponent from 'components/creation_menu/creation_menu'
import creationMenuItemTypes from 'helpers/enums/creationMenuItemTypes'

import styles from './add.scss'

import GSTooltipImage from 'assets/components/main_topbar/GS-tooltip-header.svg'
import newIcon from 'assets/components/main_topbar/new-icon.svg'
import arrowCreateIcon from 'assets/components/main_topbar/arrow-create-icon.svg'

class AddButton extends PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			visible: false,
		}
	}

	componentDidUpdate(_, prevState) {
		if (!prevState.visible && this.state.visible) {
			this.props.handlePlusIconToggled()
		}
	}

	toggleAddButton = () => {
		this.setState(prevState => ({
			visible: !prevState.visible,
		}))
	}

	closeAddButton = () => {
		if (this.state.visible) {
			this.toggleAddButton()
		}
	}

	FUNCTIONS = {
		[creationMenuItemTypes.LESSON]: this.props.addLessonHandler,
		[creationMenuItemTypes.GOOGLE_SLIDE]: this.props.addGoogleSlideHandler,
		[creationMenuItemTypes.INTERACTIVE_VIDEO]: this.props.addInteractiveVideoHandler,
		[creationMenuItemTypes.FOLDER]: this.props.addFolderHandler,
	}

	onSelect = data => {
		if (this.FUNCTIONS[data.id]) {
			this.FUNCTIONS[data.id]()
		}
		this.closeAddButton()
	}

	renderAddDropdown() {
		if (this.props.shouldShowTooltipGSCreateLesson) {
			return (
				<div styleName='tooltip'>
					<HintTooltip
						type='tooltipGSCreateLesson'
						hintText={localize('googleSlides_addTooltip_text')}
						hintButton={localize('googleSlides_addTooltip_button')}
						arrowPosition='top-right'
						centeredContent
						headerImage={GSTooltipImage}
						onButtonClick={this.closeTooltip}
					/>
				</div>
			)
		}

		return (
			<div
				styleName={classNames({
					dropdown: true,
					'dropdown--bigger': this.props.shouldUpdateCreateLesson,
				})}
			>
				<CreationMenuComponent
					onSelect={this.onSelect}
					canCreateInteractiveVideo={this.props.canCreateInteractiveVideo}
					shouldShowFolderDropdownOption={this.props.shouldShowFolderDropdownOption}
					shouldUpdateCreateLesson={this.props.shouldUpdateCreateLesson}
				/>
			</div>
		)
	}

	render() {
		if (this.props.shouldShowAddButton === false) {
			return null
		}

		let icon = newIcon
		let label = localize('main_topBar_addButton_label')
		if (this.props.shouldUpdateCreateLesson) {
			icon = arrowCreateIcon
			label = localize('main_topBar_addButton_label_2')
		}

		return (
			<ClickOutside
				clickOutsideHandler={this.closeAddButton}>
				<div styleName='wrapper'>
					<TopbarButton
						icon={icon}
						label={label}
						buttonHandler={this.toggleAddButton}
						isActive={this.state.visible}
						shouldUpdateCreateLesson={
							this.props.shouldUpdateCreateLesson
						}
					/>
					{ this.state.visible && this.renderAddDropdown() }
				</div>
			</ClickOutside>
		)
	}
}

AddButton.defaultProps = {
	shouldShowAddButton: true,
	shouldShowTooltipGSCreateLesson: false,
	addLessonHandler: () => {},
	addFolderHandler: () => {},
	addGoogleSlideHandler: () => {},
	handlePlusIconToggled: () => {},
	canCreateInteractiveVideo: false,
	addInteractiveVideoHandler: () => {},
	shouldUpdateCreateLesson: false,
}

AddButton.propTypes = {
	shouldShowAddButton: PropTypes.bool,
	shouldShowFolderDropdownOption: PropTypes.bool,
	shouldShowTooltipGSCreateLesson: PropTypes.bool,
	addLessonHandler: PropTypes.func,
	addFolderHandler: PropTypes.func,
	addGoogleSlideHandler: PropTypes.func,
	handlePlusIconToggled: PropTypes.func,
	canCreateInteractiveVideo: PropTypes.bool,
	addInteractiveVideoHandler: PropTypes.func,
	shouldUpdateCreateLesson: PropTypes.bool,
}

export default CSSModules(AddButton, styles, {allowMultiple: true})
